<template>
  <div class="tree-dropdown">
    <!-- 触发图标 -->
    <div class="trigger-icon" @click="toggleDropdown">
      <i :class="isDropdownVisible ? 'el-icon-close' : 'el-icon-s-fold'"></i> <!-- 动态切换图标 -->
    </div>

    <!-- 下拉菜单 -->
    <transition name="slide-down">
      <div v-if="isDropdownVisible" class="dropdown-menu">
        <el-tree :data="treeData" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'TreeDropdown',
  props: {
    // 树形数据，由父组件传入
    treeData: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      isDropdownVisible: false, // 控制下拉菜单的显示
      defaultProps: {
        children: 'children', // 树形结构的子节点字段
        label: 'navigationName', // 根据你的数据结构，显示文本字段为 navigationName
      },
    };
  },
  methods: {
    // 切换下拉菜单的显示状态
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    // 处理树节点点击事件
    handleNodeClick(data) {
      this.$emit('node-click', data); // 向父组件传递点击的节点数据
      this.isDropdownVisible = false; // 点击后关闭下拉菜单
    },
  },
};
</script>

<style scoped>
.tree-dropdown {
  position: relative;
  display: inline-block;
}

.trigger-icon {
  font-size: 32px;
  cursor: pointer;
  padding: 10px;
  position: absolute;
  top: 10px;
  right: 0;
  /* 图标固定在右上角 */
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: -30px;
  background-color: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 100;
  width: 400px;
  /* 限制最大高度 */
  overflow-y: auto;
  /* 超出内容滚动 */
  white-space: normal;
  /* 允许内容换行 */
}

/* 下滑动画 */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}

.slide-down-enter-from,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>